import { isPrivateWhiteLabel } from '../utils/isPrivateWhiteLabel';
import fetchBootstrap from './fetchBootstrap';
import { start } from './index';

const getEl = () => {
    const el = document.getElementById('root');
    try {
        el.setAttribute('data-reactroot', 'true');
        return el;
    } catch (e) {
        return el;
    }
};

function addGtm(id) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
    });
    const firstTag = document.getElementsByTagName('script')[0];
    const newTag = document.createElement('script');
    newTag.async = true;
    newTag.src = `//www.googletagmanager.com/gtm.js?id=GTM-${id}`;
    firstTag.parentNode.insertBefore(newTag, firstTag);
}

export async function bootstrapAndStart() {
    window.ZD.configs.BRANCH_SDK_KEY = window.BRANCH_SDK_KEY;
    window.ZD.configs.TOUCH = window.TOUCH;

    const url = window.location.href;
    let bootstrap = window.__REDUX_STATE__.bookingInit;
    if (!bootstrap.loadedServerSide) {
        bootstrap = await fetchBootstrap(url);
    }

    const shouldSkipGtm = isPrivateWhiteLabel(bootstrap.directoryId);

    if (bootstrap.googleTagManagerCode && !shouldSkipGtm) {
        addGtm(bootstrap.googleTagManagerCode);
    }

    start({
        el: getEl(),
        bootstrap,
        touch: true,
    });
}

bootstrapAndStart();
